import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Candidate } from './candidate';
import { Employer } from './employer';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  //itemDoc: AngularFirestoreDocument<Candidate>;
  candidateCollection: AngularFirestoreCollection<Candidate>;
  employerCollection: AngularFirestoreCollection<Employer>;
  baseUrl = ''

  constructor(public auth: AngularFireAuth, private afs: AngularFirestore, private router: Router, private http: HttpClient) {
    this.candidateCollection = this.afs.collection('candidates')
    this.employerCollection = this.afs.collection('employers')
    if (environment.production) {
      this.baseUrl = ''
    } else {
      this.baseUrl = 'http://localhost:5000'
    }
  }

  signUp(email: string, password: string) {
    return this.auth.auth.createUserWithEmailAndPassword(email, password);
  }

  signIn(email: string, password: string) {
    return this.auth.auth.signInWithEmailAndPassword(email, password);
  }

  candidateSignUp(email: string, password: string, data: Candidate) {
    return new Promise((resolve,reject)=>{
    this.signUp(email, password).then(
      (a) => {
        data['_id'] = a.user.uid;
        // data['_id']= a.user.uid;
        console.log(data);
        this.http.post(`${this.baseUrl}/api/createCandidate`, data, { responseType: 'json' }).subscribe(
          (a) => {
            console.log(a);
            resolve(data) 
          },err => {
            resolve(data)
          }
        )
        //this.candidateCollection.add(data)
      }
    )
    });
  }

  checkRole(uid) {
    return this.http.get(`${this.baseUrl}/api/checkRole?uid=${uid}`)
  }

  employerSignUp(email: string, password: string, data: Employer) {
    return this.signUp(email, password).then(
      (a) => {
        data['_id'] = a.user.uid;
        console.log(data);
        this.http.post(`${this.baseUrl}/api/createEmployer`, JSON.stringify(data), { responseType: 'json' }).subscribe(
          (b) => {
            console.log(b);
            this.http.get(`${this.baseUrl}/api/setEmployerRole?uid=${a.user.uid}`).subscribe(
              (c) => {
                console.log(c)
                // this.router.navigate([''])
              }
            )
          }
        )
      }
    )
  }

  getLoginStatus() {
    return this.auth.authState
  }

  signOut() {
    localStorage.clear()
    return this.auth.auth.signOut();
  }

  getUserId() {
    return this.auth.user;
  }

  sendMail(email) {
    return this.http.get(`${this.baseUrl}/api/sendSignupMail?email=${email}`)
  }

  sendPasswordResetEmail(email){
    return this.auth.auth.sendPasswordResetEmail(email)
  }

  confirmPasswordReset(code,password){
    return this.auth.auth.confirmPasswordReset(code, password)
  }
}
